import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DiariseOptionModel } from '../../../models/diarise-option.model';
import { DiariseUnit } from '../../../enums/diarise-unit';
import { DiariseOptionClickEvent } from '../../../events/diarise-option-click-event';


export class E5coreUiTimePickerBaseComponent implements OnInit {
  
  @Output() public timeChange: EventEmitter<string> = new EventEmitter<string>();
  ngOnInit(): void {
    
  }
     
  public onTimeChange(time: any) 
  {
    this.timeChange.emit(time);
  }
}
